import { render, staticRenderFns } from "./bankPaymentCode.vue?vue&type=template&id=562e1e5b"
import script from "./bankPaymentCode.vue?vue&type=script&lang=js"
export * from "./bankPaymentCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports